/** ต้องตรงกับ API SitePublicRefHelper — encode จาก profile.id (ไม่ใช่ parking_site.id) */
const XOR_KEY = 0xa5c31f7b;
const PREFIX = 'cp';

function toInt32(n: number): number {
  return n | 0;
}

/** encode profile id → opaque token ใน URL (/lot/:ref) */
export function encodeSitePublicRef(profileId: number): string {
  if (!profileId || profileId <= 0) return '';
  const mixed = toInt32(profileId ^ XOR_KEY);
  const bytes = new Uint8Array(4);
  bytes[0] = (mixed >>> 24) & 0xff;
  bytes[1] = (mixed >>> 16) & 0xff;
  bytes[2] = (mixed >>> 8) & 0xff;
  bytes[3] = mixed & 0xff;
  let binary = '';
  bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });
  const b64 = btoa(binary).replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
  return PREFIX + b64;
}

export function tryDecodeSitePublicRef(refToken?: string | null): number | null {
  if (!refToken || !refToken.startsWith(PREFIX)) return null;
  let b64 = refToken.slice(PREFIX.length).replace(/-/g, '+').replace(/_/g, '/');
  while (b64.length % 4) b64 += '=';
  try {
    const binary = atob(b64);
    if (binary.length !== 4) return null;
    const mixed =
      ((binary.charCodeAt(0) << 24) |
        (binary.charCodeAt(1) << 16) |
        (binary.charCodeAt(2) << 8) |
        binary.charCodeAt(3)) >>>
      0;
    const id = toInt32(mixed ^ XOR_KEY);
    return id > 0 ? id : null;
  } catch {
    return null;
  }
}
